
import axios from 'axios';
import { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';

import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';
        
import { addManagerList2MemberList, addAssignList2MemberList, addNumber2MemberList, getChip, getFace, updateManagerSupervisorList, sortMemberList, isSelected, getServiceListItem } from '../Utilities/common';
import { DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

import mui from '../Imports/muiImports';
import reducer from '../Imports/reducerImports';
import component from '../Imports/componentImports';
import { useShared } from '../Utilities/allContext1';
import { setSupervisorList, setManagerList } from '../Redux/allReducer';

export default function CardLeftHandSide({serviceId}){

    const { setMemberList } = reducer;
    const { MemberTable, DataGrid1 } = component;  
    const { updateDBSupervisorList, updateDBManagerList, getAssignList, updateAssignList, getServiceList, getMemberList } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const memberList = useSelector((state) => state.all.memberList);
    const managerList = useSelector((state) => state.all.managerList);
    const assignList = useSelector((state) => state.all.assignList);
    const serviceList = useSelector((state) => state.all.serviceList);

    const [selectedMemberList1, setSelectedMemberList1] = useState([]);
    const [selectedMemberList3, setSelectedMemberList3] = useState([]);

    const CustomComponent = ({ member }) => {
        return member.chineseName;
    };

    useEffect(() => {
        if (memberList.length > 0 && assignList.length > 0) {
            const filteredAssignList = assignList.filter(assignListItem => assignListItem.serviceId === serviceId);
            const filteredMemberList = memberList.filter(memberListItem => filteredAssignList.some(assignListItem => assignListItem.memberId === memberListItem.id));
            setSelectedMemberList3(filteredMemberList);
        }
        if (memberList.length > 0 && managerList.length > 0) {
        const filteredManagerList = managerList.filter(managerListItem => managerListItem.serviceId === serviceId);
        const filteredMemberList = memberList.filter(memberListItem => filteredManagerList.some(listItem => listItem.memberId === memberListItem.id));
        setSelectedMemberList1(filteredMemberList); // get full details of each manager in this service
        }          
    }, [serviceId, assignList, memberList]);

    return (
        <>
            {/* {serviceList[serviceId-1]?.name}<br/><br/> */}
            
            {/* Loop through all managers in selectedMemberList1 */}
            {selectedMemberList1 && selectedMemberList1.length > 0 && (
                <div>
                    {selectedMemberList1.map((manager, index) => (
                        <div key={manager.id || index}>
                            {manager.chineseName}
                        </div>
                    ))}
                </div>
            )}
            <br/>
            {selectedMemberList3.length}位
        </>        
    );

}